import { formatUrlTrailing } from '@Utils/urlFormatting';
import { axiosWithHeaders, getService } from '@innovyze/lib_get_service';
import config, { apiEnv } from './config.api';

const inspectionService = axiosWithHeaders({
	service: 'amInspection',
	config,
	axiosCreateOpts: { timeout: 30000 },
});

export const inspectionBaseUrl = formatUrlTrailing(
	getService('amInspection', config, apiEnv),
);

export default inspectionService;
